export default "__VITE_ASSET__QEd6AQcu__"